module.exports = __webpack_public_path__ + "static/media/platinum-tier-person.1f030193.svg";